import { SvgIcon, SvgIconProps } from "@mui/material";

export const EntityTypeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        opacity="0.2"
        d="M17.9993 26.9961V4.99609C17.9993 4.73088 17.8939 4.47652 17.7064 4.28899C17.5188 4.10145 17.2645 3.99609 16.9993 3.99609H4.99927C4.73405 3.99609 4.4797 4.10145 4.29216 4.28899C4.10462 4.47652 3.99927 4.73088 3.99927 4.99609V26.9961"
        fill="#23BD33"
      />
      <path d="M2 26.9961H30" stroke="#23BD33" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.9993 26.9961V4.99609C17.9993 4.73088 17.8939 4.47652 17.7064 4.28899C17.5188 4.10145 17.2645 3.99609 16.9993 3.99609H4.99927C4.73405 3.99609 4.4797 4.10145 4.29216 4.28899C4.10462 4.47652 3.99927 4.73088 3.99927 4.99609V26.9961"
        stroke="#23BD33"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9993 26.9961V12.9961C27.9993 12.7309 27.8939 12.4765 27.7064 12.289C27.5188 12.1015 27.2645 11.9961 26.9993 11.9961H17.9993"
        stroke="#23BD33"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99927 8.99609H11.9993"
        stroke="#23BD33"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99927 16.9961H13.9993"
        stroke="#23BD33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99927 21.9961H11.9993"
        stroke="#23BD33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9993 21.9961H23.9993"
        stroke="#23BD33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9993 16.9961H23.9993"
        stroke="#23BD33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EntityCountryIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        opacity="0.2"
        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
        fill="#564FFD"
      />
      <path
        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
        stroke="#564FFD"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M4 16H28" stroke="#564FFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16 27.676C18.7614 27.676 21 22.4477 21 15.9982C21 9.54867 18.7614 4.32031 16 4.32031C13.2386 4.32031 11 9.54867 11 15.9982C11 22.4477 13.2386 27.676 16 27.676Z"
        stroke="#564FFD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  );
};

export const EntityNationalLevelIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        opacity="0.2"
        d="M7 7V13.887C7 18.8496 10.9693 22.963 15.9318 22.9997C17.1194 23.0088 18.297 22.7826 19.3968 22.3344C20.4966 21.8861 21.4968 21.2246 22.3398 20.388C23.1828 19.5514 23.8518 18.5563 24.3084 17.4599C24.7649 16.3635 25 15.1876 25 14V7C25 6.73478 24.8946 6.48043 24.7071 6.29289C24.5196 6.10536 24.2652 6 24 6H8C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7Z"
        fill="#1D2026"
      />
      <path
        d="M7 7V13.887C7 18.8496 10.9693 22.963 15.9318 22.9997C17.1194 23.0088 18.297 22.7826 19.3968 22.3344C20.4966 21.8861 21.4968 21.2246 22.3398 20.388C23.1828 19.5514 23.8518 18.5563 24.3084 17.4599C24.7649 16.3635 25 15.1876 25 14V7C25 6.73478 24.8946 6.48043 24.7071 6.29289C24.5196 6.10536 24.2652 6 24 6H8C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7Z"
        stroke="#1D2026"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 28H20" stroke="#1D2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 23V28" stroke="#1D2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M24.7769 16H25.9999C27.0608 16 28.0782 15.5786 28.8283 14.8284C29.5785 14.0783 29.9999 13.0609 29.9999 12V10C29.9999 9.73478 29.8945 9.48043 29.707 9.29289C29.5195 9.10536 29.2651 9 28.9999 9H24.9999"
        stroke="#1D2026"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.24552 16H5.98413C4.92326 16 3.90585 15.5786 3.1557 14.8284C2.40556 14.0783 1.98413 13.0609 1.98413 12V10C1.98413 9.73478 2.08949 9.48043 2.27702 9.29289C2.46456 9.10536 2.71891 9 2.98413 9H6.98413"
        stroke="#1D2026"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EntityFoundationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path opacity="0.2" d="M26 6V10H6V6H26Z" fill="#1D2026" stroke="#1D2026" strokeWidth="2" />
      <path
        d="M26 5H6C5.44772 5 5 5.44772 5 6V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V6C27 5.44772 26.5523 5 26 5Z"
        stroke="#1D2026"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 3V7" stroke="#1D2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 3V7" stroke="#1D2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 11H27" stroke="#1D2026" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.5 16H15L13 18.5C13.3289 18.5 13.6526 18.5811 13.9427 18.7361C14.2327 18.8911 14.48 19.1152 14.6628 19.3886C14.8455 19.662 14.958 19.9763 14.9903 20.3035C15.0226 20.6308 14.9737 20.9609 14.848 21.2648C14.7222 21.5687 14.5235 21.8368 14.2694 22.0455C14.0153 22.2543 13.7136 22.3971 13.3911 22.4614C13.0686 22.5257 12.7352 22.5095 12.4205 22.4142C12.1057 22.3189 11.8193 22.1475 11.5866 21.9151"
        stroke="#1D2026"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18 17.5L20 16V22.5" stroke="#1D2026" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const EntityNationalLeagueIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20.9", height: "24", fill: "none" }}
      width="20.9"
      height="24"
      viewBox="0 0 20.9 24"
      fill="none"
    >
      <path
        d="M20.8023 2.61084C20.4101 1.07344 19.0916 0 17.5958 0C17.5956 0 17.5952 0 17.595 0H15.6818H5.23907H3.32615C3.32587 0 3.32563 0 3.32535 0C1.82957 0 0.511021 1.07353 0.118818 2.61075C-0.0811038 3.39441 -0.127229 4.63528 0.788802 6.09619C1.48851 7.21219 2.62649 8.24119 4.17318 9.16106C4.36504 12.076 6.54655 14.4563 9.3696 14.9534V17.3428H5.98504C5.38255 17.3428 4.89411 17.8312 4.89411 18.4337V22.9091C4.89411 23.5116 5.38255 24 5.98504 24H14.936C15.5385 24 16.0269 23.5116 16.0269 22.9091V18.4336C16.0269 17.8312 15.5385 17.3427 14.936 17.3427H11.5514V14.9553C14.3818 14.4626 16.57 12.0765 16.7591 9.1545C18.3002 8.23641 19.4343 7.20956 20.1323 6.09623C21.0483 4.63533 21.0022 3.39455 20.8023 2.61084ZM2.23283 3.15019C2.39516 2.51442 2.90521 2.18184 3.32572 2.18184H3.32596H4.14983L4.15588 6.52439C2.4689 5.2275 2.0203 3.98311 2.23283 3.15019ZM13.845 19.5246V21.8182H7.07587V19.5246H13.845ZM14.591 8.51231C14.591 8.51531 14.591 8.51827 14.591 8.52127V8.74308C14.591 11.0171 12.7408 12.8672 10.4666 12.8672C8.19158 12.8672 6.34077 11.0172 6.34077 8.74158L6.33163 2.18189H14.5911V8.51231H14.591ZM16.7728 6.51853V2.1818H17.5954H17.5956C18.0158 2.1818 18.5261 2.51447 18.6883 3.15023C18.9004 3.98198 18.4536 5.22384 16.7728 6.51853Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const EntityNationalCupIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20.9", height: "24", fill: "none" }}
      width="20.9"
      height="24"
      viewBox="0 0 20.9 24"
      fill="none"
    >
      <path
        d="M20.8023 2.61084C20.4101 1.07344 19.0916 0 17.5958 0C17.5956 0 17.5952 0 17.595 0H15.6818H5.23907H3.32615C3.32587 0 3.32563 0 3.32535 0C1.82957 0 0.511021 1.07353 0.118818 2.61075C-0.0811038 3.39441 -0.127229 4.63528 0.788802 6.09619C1.48851 7.21219 2.62649 8.24119 4.17318 9.16106C4.36504 12.076 6.54655 14.4563 9.3696 14.9534V17.3428H5.98504C5.38255 17.3428 4.89411 17.8312 4.89411 18.4337V22.9091C4.89411 23.5116 5.38255 24 5.98504 24H14.936C15.5385 24 16.0269 23.5116 16.0269 22.9091V18.4336C16.0269 17.8312 15.5385 17.3427 14.936 17.3427H11.5514V14.9553C14.3818 14.4626 16.57 12.0765 16.7591 9.1545C18.3002 8.23641 19.4343 7.20956 20.1323 6.09623C21.0483 4.63533 21.0022 3.39455 20.8023 2.61084ZM2.23283 3.15019C2.39516 2.51442 2.90521 2.18184 3.32572 2.18184H3.32596H4.14983L4.15588 6.52439C2.4689 5.2275 2.0203 3.98311 2.23283 3.15019ZM13.845 19.5246V21.8182H7.07587V19.5246H13.845ZM14.591 8.51231C14.591 8.51531 14.591 8.51827 14.591 8.52127V8.74308C14.591 11.0171 12.7408 12.8672 10.4666 12.8672C8.19158 12.8672 6.34077 11.0172 6.34077 8.74158L6.33163 2.18189H14.5911V8.51231H14.591ZM16.7728 6.51853V2.1818H17.5954H17.5956C18.0158 2.1818 18.5261 2.51447 18.6883 3.15023C18.9004 3.98198 18.4536 5.22384 16.7728 6.51853Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const EntityNationalTournamentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "24", fill: "none" }}
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
    >
      <path
        d="M19 1H16C16 0.447705 15.5523 0 15 0H5C4.4477 0 4 0.447705 4 1H1C0.447705 1 0 1.4477 0 2V3C0 5.53267 1.8835 7.62544 4.32603 7.95464C4.79985 9.32998 5.75947 10.4791 7 11.1969V18H6.996C5.3417 18 4 19.3417 4 20.996V22H3C2.44771 22 2 22.4477 2 23C2 23.5523 2.44771 24 3 24H5H15H17C17.5523 24 18 23.5523 18 23C18 22.4477 17.5523 22 17 22H16V20.996C16 19.3417 14.6583 18 13.004 18H13V11.1969C14.2405 10.4791 15.2002 9.32998 15.674 7.95464C18.1165 7.62544 20 5.53271 20 3V2C20 1.4477 19.5523 1 19 1ZM2 3H4V5.82925C2.83486 5.41738 2 4.3061 2 3ZM6 2H14V6C14 8.20869 12.2087 10 10 10C7.79126 10 6 8.20869 6 6V2ZM14 20.996V22H6V20.996C6 20.4463 6.44629 20 6.996 20H7.99014C7.99346 20 7.99668 20.0005 8 20.0005H12C12.0033 20.0005 12.0065 20 12.0099 20H13.004C13.5537 20 14 20.4463 14 20.996ZM9 18V12.0005H11V18H9ZM16 5.82925V3H18C18 4.3061 17.1651 5.41738 16 5.82925Z"
        fill="black"
      />
      <path
        d="M8.20957 8.13599L9.99956 6.971L11.7896 8.13599L11.1065 6.03101L12.8966 4.798H10.7235L9.99956 2.625L9.31558 4.798H7.10254L8.89258 6.03101L8.20957 8.13599Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const EntityInternationalTournamentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "30", height: "30", fill: "none" }}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M9.56421 22.1665H11.5753V17.0097C11.0809 16.6803 10.6183 16.2867 10.1972 15.8318C8.78032 14.301 8 12.2658 8 10.1009C8 7.9361 8.7804 5.90083 10.1972 4.36998C13.1222 1.20996 17.8814 1.21005 20.8063 4.36998C23.7312 7.53008 23.7312 12.6717 20.8063 15.8317C20.2087 16.4774 19.5276 17.0002 18.7897 17.3895V22.1664H20.801C21.2417 22.1664 21.5991 22.5524 21.5991 23.0286V27.1378C21.5991 27.6139 21.2417 28 20.801 28H9.56421C9.12348 28 8.76614 27.6139 8.76614 27.1378V23.0286C8.76614 22.5526 9.12348 22.1665 9.56421 22.1665ZM19.0749 15.1805L15.5019 11.3203L15.1313 11.7206C16.1102 13.0354 16.6776 14.6516 16.7545 16.3366C17.5967 16.141 18.3857 15.7487 19.0749 15.1805ZM21.2697 11.4547C19.7115 11.3707 18.2174 10.7568 17.0014 9.70034L16.6306 10.1009L20.203 13.9604C20.7363 13.2032 21.0918 12.346 21.2697 11.4547ZM20.2029 6.24146L18.1238 8.48762C19.0683 9.25974 20.2094 9.70472 21.3955 9.75812C21.334 8.51178 20.936 7.28225 20.2029 6.24146ZM9.73008 8.7477C11.2895 8.83096 12.7856 9.44384 14.0026 10.5013L14.3732 10.1009L10.8002 6.24076C10.2742 6.98539 9.9111 7.83797 9.73008 8.7477ZM10.8002 13.9611L12.8799 11.7142C11.9347 10.9413 10.7931 10.4959 9.60497 10.4433C9.6676 11.7304 10.0831 12.9461 10.8002 13.9611ZM15.5019 8.88156L15.8723 8.48131C14.8943 7.16757 14.3269 5.55294 14.2493 3.8695C13.4242 4.06157 12.6306 4.44561 11.9295 5.02208L15.5019 8.88156ZM15.8191 3.73363C15.8685 5.01569 16.2804 6.24811 16.9952 7.26833L19.0742 5.02208C18.1109 4.23017 16.9727 3.80008 15.8191 3.73363ZM15.1848 16.4717C15.1359 15.1885 14.7239 13.9548 14.0085 12.9337L11.9288 15.1805C12.8683 15.9551 13.9935 16.4041 15.1848 16.4717ZM15.5019 18.2057C14.6983 18.2057 13.9142 18.0698 13.1715 17.8087V22.0913H17.1938V17.9995C16.6452 18.1355 16.0786 18.2057 15.5019 18.2057ZM10.3623 26.2758H20.0029V23.8909H10.3623V26.2758Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const EntityAchievementGalleryIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.5102 2.4898V14.4C2.5102 14.7314 2.77884 15 3.11021 15L19.4 14.9999C19.7314 14.9999 20 14.7312 20 14.3999V3.08966C20 2.75829 19.7314 2.48966 19.4 2.48966L2.5102 2.4898ZM18.7551 12.898L16.2449 8.73469L13.4082 11.1021L11.245 7.4898L3.75517 13.7347V3.73469H18.7552L18.7551 12.898ZM5 6.85714C5 7.89792 5.83677 8.73469 6.87755 8.73469C7.91833 8.73469 8.7551 7.89792 8.7551 6.85714C8.7551 5.81636 7.91833 4.97959 6.87755 4.97959C5.83677 4.97959 5 5.83674 5 6.85714ZM17.4897 0.599932C17.4897 0.268588 17.2211 0 16.8897 0H0.600001C0.26863 0 0 0.268629 0 0.6V11.9102C0 12.2416 0.268629 12.5102 0.6 12.5102H0.644898C0.976269 12.5102 1.2449 12.2416 1.2449 11.9102V1.2449H16.8897C17.2211 1.2449 17.4898 0.976227 17.4897 0.644829L17.4897 0.599932Z"
        fill="#039103"
      />
    </SvgIcon>
  );
};

export const EntityBackToProfileIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const CreateNewGroupButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M6 1V11" stroke="#008B07" strokeWidth="2" strokeLinecap="round" />
      <path d="M11 6L1 6" stroke="#008B07" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const GroupCardPrivacyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "20", fill: "none" }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M2.1665 9.99996H18.8332M2.1665 9.99996C2.1665 14.6023 5.89746 18.3333 10.4998 18.3333M2.1665 9.99996C2.1665 5.39759 5.89746 1.66663 10.4998 1.66663M18.8332 9.99996C18.8332 14.6023 15.1022 18.3333 10.4998 18.3333M18.8332 9.99996C18.8332 5.39759 15.1022 1.66663 10.4998 1.66663M10.4998 1.66663C12.5842 3.94859 13.7688 6.90999 13.8332 9.99996C13.7688 13.0899 12.5842 16.0513 10.4998 18.3333M10.4998 1.66663C8.41544 3.94859 7.23088 6.90999 7.1665 9.99996C7.23088 13.0899 8.41544 16.0513 10.4998 18.3333"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const GroupCardSeeDetailsButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.1665 9.99996H15.8332M15.8332 9.99996L9.99984 4.16663M15.8332 9.99996L9.99984 15.8333"
        stroke="#008B07"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowBackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M15 19L7 11L15 3" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const ArrowBackButtonEditIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const AccordionExpandIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#98A2B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AccordionCollapseIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#98A2B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const BranchFacilityIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const BranchSportIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#C9FFC4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9457 8.62096L11.5923 16.6826L9.37568 14.3143C8.96734 13.9293 8.32568 13.906 7.85901 14.2326C7.40401 14.571 7.27568 15.166 7.55568 15.6443L10.1807 19.9143C10.4373 20.311 10.8807 20.556 11.3823 20.556C11.8607 20.556 12.3157 20.311 12.5723 19.9143C12.9923 19.366 21.0073 9.81096 21.0073 9.81096C22.0573 8.73762 20.7857 7.79262 19.9457 8.60929V8.62096Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const NationalLeagueIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.67961 11.9184L5.43961 9.99844H2.95992L3.38042 11.2617C3.51194 11.6544 3.87863 11.9184 4.29144 11.9184H5.67961ZM12.2643 12.9975L13.5996 2.31844H6.39961L7.73496 12.9975C7.79448 13.4775 8.20249 13.8384 8.68728 13.8384H11.3119C11.7967 13.8384 12.2047 13.4775 12.2643 12.9975ZM16.6188 11.2617L17.0393 9.99844H14.5596L14.3196 11.9184H15.7078C16.1206 11.9184 16.4873 11.6544 16.6188 11.2617ZM7.11961 19.5984V17.6784H9.03961V15.7584H7.85496C6.88632 15.7584 6.06937 15.0375 5.94937 14.0766L5.91961 13.8384H3.70392C2.87736 13.8384 2.14297 13.3093 1.88186 12.525L0.399609 8.07844H5.19961L4.23961 0.398438H15.7596L14.7996 8.07844H19.5996L18.1174 12.525C17.8562 13.3093 17.1219 13.8384 16.2953 13.8384H14.0796L14.0498 14.0766C13.9298 15.0375 13.1129 15.7584 12.1443 15.7584H10.9596V17.6784H12.8796V19.5984H7.11961Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const NationalCupIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "17", height: "20", fill: "none" }}
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
    >
      <path
        d="M16.6418 2.48711C16.3281 1.25719 15.2733 0.398438 14.0766 0.398438C14.0764 0.398438 14.0762 0.398438 14.076 0.398438H12.5455H4.19125H2.66092C2.66069 0.398438 2.6605 0.398438 2.66028 0.398438C1.46365 0.398438 0.408817 1.25726 0.0950545 2.48704C-0.064883 3.11396 -0.101783 4.10666 0.631042 5.27539C1.1908 6.16819 2.10119 6.99139 3.33854 7.72729C3.49203 10.0593 5.23724 11.9635 7.49568 12.3611V14.2727H4.78803C4.30604 14.2727 3.91529 14.6634 3.91529 15.1454V18.7257C3.91529 19.2077 4.30604 19.5984 4.78803 19.5984H11.9488C12.4308 19.5984 12.8215 19.2077 12.8215 18.7257V15.1454C12.8215 14.6634 12.4308 14.2726 11.9488 14.2726H9.24116V12.3627C11.5054 11.9685 13.256 10.0596 13.4073 7.72204C14.6401 6.98756 15.5474 6.16609 16.1058 5.27542C16.8387 4.1067 16.8018 3.11408 16.6418 2.48711ZM1.78627 2.91859C1.91613 2.40998 2.32417 2.14391 2.66058 2.14391H2.66077H3.31987L3.3247 5.61795C1.97512 4.58044 1.61624 3.58493 1.78627 2.91859ZM11.076 16.0181V17.853H5.66069V16.0181H11.076ZM11.6728 7.20829C11.6728 7.21069 11.6728 7.21305 11.6728 7.21545V7.3929C11.6728 9.21214 10.1926 10.6922 8.37325 10.6922C6.55327 10.6922 5.07262 9.21221 5.07262 7.3917L5.06531 2.14395H11.6728V7.20829H11.6728ZM13.4182 5.61326V2.14388H14.0763H14.0765C14.4127 2.14388 14.8209 2.41001 14.9507 2.91863C15.1203 3.58403 14.7628 4.57751 13.4182 5.61326Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const NationalTournamentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "20", fill: "none" }}
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        d="M15.2 1.19844H12.8C12.8 0.756602 12.4418 0.398438 12 0.398438H4C3.55816 0.398438 3.2 0.756602 3.2 1.19844H0.8C0.358164 1.19844 0 1.5566 0 1.99844V2.79844C0 4.82457 1.5068 6.49879 3.46082 6.76215C3.83988 7.86242 4.60758 8.78176 5.6 9.35598V14.7984H5.5968C4.27336 14.7984 3.2 15.8718 3.2 17.1952V17.9984H2.4C1.95816 17.9984 1.6 18.3566 1.6 18.7984C1.6 19.2403 1.95816 19.5984 2.4 19.5984H4H12H13.6C14.0418 19.5984 14.4 19.2403 14.4 18.7984C14.4 18.3566 14.0418 17.9984 13.6 17.9984H12.8V17.1952C12.8 15.8718 11.7266 14.7984 10.4032 14.7984H10.4V9.35598C11.3924 8.78176 12.1602 7.86242 12.5392 6.76215C14.4932 6.49879 16 4.82461 16 2.79844V1.99844C16 1.5566 15.6418 1.19844 15.2 1.19844ZM1.6 2.79844H3.2V5.06184C2.26789 4.73234 1.6 3.84332 1.6 2.79844ZM4.8 1.99844H11.2V5.19844C11.2 6.96539 9.76699 8.39844 8 8.39844C6.23301 8.39844 4.8 6.96539 4.8 5.19844V1.99844ZM11.2 17.1952V17.9984H4.8V17.1952C4.8 16.7555 5.15703 16.3984 5.5968 16.3984H6.39211C6.39476 16.3985 6.39734 16.3988 6.4 16.3988H9.6C9.60266 16.3988 9.60523 16.3984 9.60789 16.3984H10.4032C10.843 16.3984 11.2 16.7555 11.2 17.1952ZM7.2 14.7984V9.99883H8.8V14.7984H7.2ZM12.8 5.06184V2.79844H14.4C14.4 3.84332 13.7321 4.73234 12.8 5.06184Z"
        fill="black"
      />
      <path
        d="M6.56727 6.90879L7.99926 5.9768L9.43125 6.90879L8.88484 5.22481L10.3169 4.2384H8.57844L7.99926 2.5L7.45207 4.2384H5.68164L7.11367 5.22481L6.56727 6.90879Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const InternationalTournamentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.65176 17.7348H9.26063V13.6093C8.86507 13.3458 8.49506 13.0309 8.15816 12.667C7.02465 11.4424 6.40039 9.81417 6.40039 8.08231C6.40039 6.35044 7.02471 4.72223 8.15816 3.49754C10.4981 0.969534 14.3055 0.969604 16.6455 3.49754C18.9854 6.02563 18.9854 10.1389 16.6455 12.6669C16.1673 13.1835 15.6225 13.6017 15.0322 13.9132V17.7346H16.6412C16.9938 17.7346 17.2796 18.0435 17.2796 18.4244V21.7118C17.2796 22.0927 16.9938 22.4016 16.6412 22.4016H7.65176C7.29918 22.4016 7.0133 22.0927 7.0133 21.7118V18.4244C7.0133 18.0436 7.29918 17.7348 7.65176 17.7348ZM15.2603 12.146L12.4019 9.05781L12.1054 9.37807C12.8885 10.4299 13.3425 11.7229 13.404 13.0708C14.0777 12.9144 14.709 12.6005 15.2603 12.146ZM17.0161 9.16531C15.7696 9.09815 14.5743 8.607 13.6015 7.76183L13.3049 8.08231L16.1628 11.1699C16.5895 10.5641 16.8738 9.87833 17.0161 9.16531ZM16.1627 4.99473L14.4995 6.79166C15.2551 7.40935 16.1679 7.76534 17.1168 7.80806C17.0676 6.81098 16.7492 5.82736 16.1627 4.99473ZM7.78445 6.99973C9.03199 7.06633 10.2289 7.55663 11.2025 8.40257L11.4989 8.08231L8.64052 4.99417C8.21975 5.58987 7.92927 6.27193 7.78445 6.99973ZM8.64052 11.1704L10.3043 9.37296C9.54819 8.75456 8.63488 8.3983 7.68436 8.35621C7.73447 9.38592 8.06689 10.3585 8.64052 11.1704ZM12.4019 7.10681L12.6983 6.78661C11.9158 5.73562 11.4619 4.44391 11.3998 3.09716C10.7397 3.25082 10.1048 3.55805 9.54398 4.01923L12.4019 7.10681ZM12.6557 2.98847C12.6952 4.01411 13.0247 5.00005 13.5965 5.81622L15.2598 4.01923C14.4891 3.3857 13.5786 3.04162 12.6557 2.98847ZM12.1482 13.1789C12.1091 12.1523 11.7795 11.1654 11.2072 10.3485L9.54346 12.146C10.295 12.7657 11.1952 13.1248 12.1482 13.1789ZM12.4019 14.5661C11.759 14.5661 11.1317 14.4574 10.5376 14.2485V17.6746H13.7554V14.4012C13.3166 14.5099 12.8632 14.5661 12.4019 14.5661ZM8.29021 21.0222H16.0027V19.1143H8.29021V21.0222Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const AddButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path d="M7 1V13" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
      <path d="M13 7L1 7" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const PlusButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M11.3281 5.32812C11.5156 5.32812 11.6719 5.39583 11.7969 5.53125C11.9323 5.65625 12 5.8125 12 6C12 6.1875 11.9323 6.34896 11.7969 6.48438C11.6719 6.60938 11.5156 6.67188 11.3281 6.67188H6.67188V11.3281C6.67188 11.5156 6.60417 11.6771 6.46875 11.8125C6.34375 11.9375 6.1875 12 6 12C5.8125 12 5.65104 11.9375 5.51562 11.8125C5.39062 11.6771 5.32812 11.5156 5.32812 11.3281V6.67188H0.671875C0.484375 6.67188 0.322917 6.60938 0.1875 6.48438C0.0625 6.34896 0 6.1875 0 6C0 5.8125 0.0625 5.65625 0.1875 5.53125C0.322917 5.39583 0.484375 5.32812 0.671875 5.32812H5.32812V0.671875C5.32812 0.484375 5.39062 0.328125 5.51562 0.203125C5.65104 0.0677083 5.8125 0 6 0C6.1875 0 6.34375 0.0677083 6.46875 0.203125C6.60417 0.328125 6.67188 0.484375 6.67188 0.671875V5.32812H11.3281Z"
        fill="#666666"
      />
    </SvgIcon>
  );
};

export const MinusButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "2", fill: "none" }}
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
    >
      <path
        opacity="0.5"
        d="M11.3281 0.328125C11.5156 0.328125 11.6719 0.395833 11.7969 0.53125C11.9323 0.65625 12 0.8125 12 1C12 1.1875 11.9323 1.34896 11.7969 1.48438C11.6719 1.60938 11.5156 1.67188 11.3281 1.67188H0.671875C0.484375 1.67188 0.322917 1.60938 0.1875 1.48438C0.0625 1.34896 0 1.1875 0 1C0 0.8125 0.0625 0.65625 0.1875 0.53125C0.322917 0.395833 0.484375 0.328125 0.671875 0.328125H11.3281Z"
        fill="#666666"
      />
    </SvgIcon>
  );
};

export const LocationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const RemoveLocationButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M12.5342 1.58203L11.2275 12.0391C11.165 12.5394 10.7396 12.9149 10.2354 12.915H3.7666C3.26228 12.915 2.83697 12.5395 2.77441 12.0391L1.4668 1.58203H12.5342Z"
        stroke="#CC3E3E"
        strokeWidth="2"
      />
    </SvgIcon>
  );
};

export const EditLocationButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.1055 3.89453C13.7652 3.23484 14.8354 3.23485 15.4951 3.89453L16.1055 4.50488C16.7651 5.16459 16.7652 6.23484 16.1055 6.89453L7.15137 15.8477L3.50781 16.4912L4.15137 12.8477L13.1055 3.89453Z"
        stroke="#008B07"
        strokeWidth="1.8"
      />
    </SvgIcon>
  );
};

export const NoServicesProvidedWarningIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "31", height: "30", fill: "none" }}
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M15.4998 29.5827C23.554 29.5827 30.0832 23.0535 30.0832 14.9993C30.0832 6.9452 23.554 0.416016 15.4998 0.416016C7.44568 0.416016 0.916504 6.9452 0.916504 14.9993C0.916504 23.0535 7.44568 29.5827 15.4998 29.5827Z"
        fill="#F7C000"
      />
      <path
        d="M15.4998 17.0406C15.8866 17.0406 16.2575 16.887 16.531 16.6135C16.8045 16.34 16.9582 15.9691 16.9582 15.5823V8.78646C16.9582 8.39968 16.8045 8.02875 16.531 7.75526C16.2575 7.48177 15.8866 7.32812 15.4998 7.32812C15.1131 7.32812 14.7421 7.48177 14.4686 7.75526C14.1951 8.02875 14.0415 8.39968 14.0415 8.78646V15.5823C14.0415 15.9691 14.1951 16.34 14.4686 16.6135C14.7421 16.887 15.1131 17.0406 15.4998 17.0406Z"
        fill="#F7C000"
      />
      <path
        d="M15.4997 22.6693C16.5064 22.6693 17.3226 21.8531 17.3226 20.8464C17.3226 19.8396 16.5064 19.0234 15.4997 19.0234C14.4929 19.0234 13.6768 19.8396 13.6768 20.8464C13.6768 21.8531 14.4929 22.6693 15.4997 22.6693Z"
        fill="#F7C000"
      />
    </SvgIcon>
  );
};

export const EditEntityProfileSectionButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.1055 3.89453C13.7652 3.23484 14.8354 3.23485 15.4951 3.89453L16.1055 4.50488C16.7651 5.16459 16.7652 6.23484 16.1055 6.89453L7.15137 15.8477L3.50781 16.4912L4.15137 12.8477L13.1055 3.89453Z"
        stroke="#008B07"
        strokeWidth="1.8"
      />
    </SvgIcon>
  );
};
